import {
  VISIBLE_PILLS_LIMIT,
  TEST_IDS,
} from '../constants/subcategoriesBarConstants';
import {
  buildSubcategoryHref,
  slugifySubcategory,
} from '../subcategoriesBarUtils';

export default {
  props: {
    subcategories: {
      type: Array,
      required: true,
    },
    selectedSubcategory: {
      type: String,
      default: null,
    },
    basePath: {
      type: String,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    visiblePills() {
      return this.subcategories.slice(0, VISIBLE_PILLS_LIMIT);
    },
    selectedIsOutsideVisible() {
      return (
        Boolean(this.selectedSubcategory) &&
        !this.visiblePills.some(
          pill => pill.toLowerCase() === this.selectedSubcategory.toLowerCase()
        )
      );
    },
    displayedPills() {
      if (!this.selectedIsOutsideVisible) {
        return this.visiblePills;
      }
      return [
        ...this.visiblePills.slice(0, VISIBLE_PILLS_LIMIT - 1),
        this.selectedSubcategory,
      ];
    },
    hasOverflow() {
      return this.subcategories.length > VISIBLE_PILLS_LIMIT;
    },
  },
  created() {
    this.TEST_IDS = TEST_IDS;
  },
  methods: {
    pillHref(subcategory) {
      return buildSubcategoryHref(this.basePath, subcategory);
    },
    pillTestId(subcategory) {
      return `${TEST_IDS.PILL_PREFIX}-${slugifySubcategory(subcategory)}`;
    },
    isPillActive(subcategory) {
      return (
        Boolean(this.selectedSubcategory) &&
        subcategory.toLowerCase() === this.selectedSubcategory.toLowerCase()
      );
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
